import Autoform from 'App/components/AutoForm'
import useMessage from 'App/hooks/useMessage'
import useRef from 'App/hooks/useRef'
import Button from 'orionsoft-parts/lib/components/Button'
import React, {useState} from 'react'
import styles from './styles.css'

const INCREMENT = 1
const DECREMENT = -1

export default function MedalInput({
  item,
  mutationName,
  itemIdField, // Nombre del campo que contiene el ID (e.g., "orderId" o "vehicleId")
  medalsStoreField, // Nombre del campo que contiene el total de medallas(e.g., "givesPickerUsage" o "pickerUsesLeft")
  displayCurrentMedals = false,
  displayMedalsText = '',
  refetch = null,
  shouldRender = () => true,
}) {
  const [count, setCount] = useState('0')
  const showMessage = useMessage()
  const buttonRef = useRef()

  const handleChange = increment => {
    const numValue = Number.parseInt(count) || 0
    setCount((numValue + increment).toString())
  }

  const handleInputChange = e => {
    const inputValue = e.target.value
    if (/^-?\d*$/.test(inputValue) || inputValue === '-') {
      setCount(inputValue)
    }
  }

  const onSuccess = () => {
    setCount('0')
    showMessage('Medallas editadas con éxito')
    refetch?.()
  }

  const countAsNumber = Number.parseInt(count) || 0
  const isAdd = countAsNumber >= 0
  const medalActionText = isAdd ? 'Agregar' : 'Eliminar'
  const medalCount = Math.abs(countAsNumber)

  if (!item) return null
  if (!shouldRender(item)) return null

  return (
    <div>
      {displayCurrentMedals && (
        <div>
          {displayMedalsText} <strong>{item[medalsStoreField] || 0}</strong> medallas
        </div>
      )}
      <Autoform
        buttonRef={buttonRef}
        mutation={mutationName}
        doc={{[itemIdField]: item._id, medalUses: countAsNumber}}
        onSuccess={onSuccess}
        onError={error => showMessage(error)}
      >
        <div className={styles.buttonContainer}>
          <ActionButton
            styleClass={styles.decrement}
            size={32}
            onClick={() => handleChange(DECREMENT)}
            label='-'
          />
          <input className={styles.input} type='text' value={count} onChange={handleInputChange} />
          <ActionButton
            styleClass={styles.increment}
            size={32}
            onClick={() => handleChange(INCREMENT)}
            label='+'
          />
          <div style={{marginLeft: 'auto'}}>
            <Button primary ref={buttonRef}>
              {`${medalActionText} ${medalCount}`}{' '}
            </Button>
          </div>
        </div>
      </Autoform>
    </div>
  )
}

function ActionButton({styleClass, size, onClick, label}) {
  return (
    <button
      className={`${styles.button} ${styleClass}`}
      style={{width: `${size}px`, height: `${size}px`}}
      onClick={onClick}
      type='button'
    >
      {label}
    </button>
  )
}
